import React, { useState } from "react";
import Button from "../../Components/Common/Button";
import FloatingInput from "../../Components/Common/FloatingForm";
import PhoneHeader from "../../Components/Common/PhoneHeader";

function NewTicket() {
  const [body, setbody] = useState("");
  const [title, settitle] = useState("");
  const [loading, setloading] = useState(false);
  return (
    <div className="Container" id="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          overflowY: "scroll",
        }}
      >
        <PhoneHeader text={"ثبت تیکت جدید"} />
        <div className="divider" />
        <div className="divider" />
        <div className="divider" />
        <FloatingInput
          big
          value={title}
          setValue={settitle}
          labelShort={"عنوان"}
          label={"عنوان"}
        />
        <div className="divider" />
        <textarea
          rows="4"
          className="textarea"
          cols="50"
          placeholder="متن مورد نظر خود را بنویسید"
          value={body}
          onChange={(value) => setbody(value.target.value)}
        />
        <Button title="ارسال پیام" loading={loading} />
      </div>
    </div>
  );
}

export default NewTicket;
